import { classList } from '../../../utils/string.ts';

export type ModalScrollAreaOptions = {
  border?: {
    /**
     * Defaults to true, as most scroll areas should have a top border.
     */
    top?: boolean;
  };
};

/**
 * Scroll areas in modals are standardized.
 * They share the same visual representation.
 */
export const modalScrollAreaClasses = (options: ModalScrollAreaOptions = {}) => {
  const { border = {} } = options;
  const { top = true } = border;

  return classList('grow overflow-y-auto', top && 'border-sk-grey-200 border-t-4');
};
